var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclineicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 9H18.5L13 3.5V9ZM6 2H14L20 8V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V4C4 2.89 4.89 2 6 2ZM10.5 11C8 11 6 13 6 15.5C6 18 8 20 10.5 20C13 20 15 18 15 15.5C15 13 13 11 10.5 11ZM10.5 12.5C11.2956 12.5 12.0587 12.8161 12.6213 13.3787C13.1839 13.9413 13.5 14.7044 13.5 15.5C13.5 16.06 13.35 16.58 13.08 17L9 12.92C9.42 12.65 9.94 12.5 10.5 12.5ZM7.5 15.5C7.5 14.94 7.65 14.42 7.92 14L12 18.08C11.58 18.35 11.06 18.5 10.5 18.5C9.70435 18.5 8.94129 18.1839 8.37868 17.6213C7.81607 17.0587 7.5 16.2956 7.5 15.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineicon);
export default __webpack_public_path__ + "static/media/decline.icon.811e0e4b68ad37ce9f35cb8b5840e828.svg";
export { ForwardRef as ReactComponent };